(() => {
  const initialize = (root = document) => {
    root.querySelectorAll('b2b-video-list').forEach((list) => {
      if (list.dataset.initialized === 'true') return;

      const modal = list.querySelector('[data-b2b-video-modal]');
      const player = list.querySelector('[data-b2b-video-player]');
      const closeButton = list.querySelector('[data-b2b-video-close]');
      if (!modal || !player || !closeButton) return;

      let lastTrigger = null;

      const close = () => {
        modal.hidden = true;
        player.replaceChildren();
        document.body.classList.remove('b2b-modal-open');
        if (lastTrigger) lastTrigger.focus();
      };

      list.querySelectorAll('[data-b2b-video-trigger]').forEach((trigger) => {
        trigger.addEventListener('click', () => {
          const videoId = trigger.dataset.videoId;
          if (!videoId) return;

          const iframe = document.createElement('iframe');
          iframe.src = `https://www.youtube-nocookie.com/embed/${encodeURIComponent(videoId)}?autoplay=1&rel=0`;
          iframe.title = trigger.dataset.videoTitle || 'BioEmblem video';
          iframe.allow = 'accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share';
          iframe.allowFullscreen = true;

          player.replaceChildren(iframe);
          lastTrigger = trigger;
          modal.hidden = false;
          document.body.classList.add('b2b-modal-open');
          closeButton.focus();
        });
      });

      closeButton.addEventListener('click', close);
      modal.addEventListener('click', (event) => {
        if (event.target === modal) close();
      });
      list.addEventListener('keydown', (event) => {
        if (event.key === 'Escape' && !modal.hidden) close();
        if (event.key === 'Tab' && !modal.hidden) {
          event.preventDefault();
          closeButton.focus();
        }
      });

      list.dataset.initialized = 'true';
    });
  };

  initialize();
  document.addEventListener('shopify:section:load', (event) => initialize(event.target));
})();
